<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.71,7.29C8.53,7.11,8.28,7,8,7C7.72,7,7.47,7.11,7.29,7.29C7.29,7.29,4.29,10.29,4.29,10.29C4.11,10.47,4,10.72,4,11C4,11.55,4.45,12,5,12C5.28,12,5.53,11.89,5.71,11.71C5.71,11.71,7,10.41,7,10.41C7,10.41,7,15,7,15C7,15.55,7.45,16,8,16C8.55,16,9,15.55,9,15C9,15,9,10.41,9,10.41C9,10.41,10.29,11.7,10.29,11.7C10.47,11.89,10.72,12,11,12C11.55,12,12,11.55,12,11C12,10.72,11.89,10.47,11.71,10.29C11.71,10.29,8.71,7.29,8.71,7.29C8.71,7.29,8.71,7.29,8.71,7.29ZM12,4C11.97,4,11.93,4,11.9,4.01C11.44,1.72,9.42,0,7,0C4.24,0,2,2.24,2,5C2,5.11,2.01,5.22,2.02,5.33C0.83,5.89,0,7.1,0,8.5C0,9.93,0.86,11.16,2.09,11.7C2.04,11.47,2,11.24,2,11C2,10.17,2.34,9.42,2.88,8.88C2.88,8.88,5.88,5.88,5.88,5.88C6.42,5.34,7.17,5,8,5C8.83,5,9.58,5.34,10.12,5.88C10.12,5.88,13.12,8.88,13.12,8.88C13.66,9.42,14,10.17,14,11C14,11.16,13.98,11.32,13.95,11.47C15.17,10.78,16,9.5,16,8C16,5.79,14.21,4,12,4C12,4,12,4,12,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CloudUpload',
} as DefineComponent
</script>
